import { render, staticRenderFns } from "./orderType.vue?vue&type=template&id=3cc9521f&scoped=true"
import script from "./orderType.vue?vue&type=script&lang=js"
export * from "./orderType.vue?vue&type=script&lang=js"
import style0 from "./orderType.vue?vue&type=style&index=0&id=3cc9521f&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cc9521f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/sihong_test_front_mall/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3cc9521f')) {
      api.createRecord('3cc9521f', component.options)
    } else {
      api.reload('3cc9521f', component.options)
    }
    module.hot.accept("./orderType.vue?vue&type=template&id=3cc9521f&scoped=true", function () {
      api.rerender('3cc9521f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Dictionary/orderType.vue"
export default component.exports